import { Col, InputNumber, Row, Space, Typography, Tooltip, Modal } from 'antd'
import { CarOutlined, InfoCircleOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { Add_Parking_Reserve_Api, GetByReserveId_Parking_Reserve_Api, Update_Parking_Reserve_Api } from '../../API/ParkingReserveApi';

const { Text } = Typography;

export const ParkingReserveComponent = ({ setLoading, showMessage, reserve, reportMode = false }) => {
    // =================================================================
    const [parkingReserve, setParkingReserve] = useState(null);
    const [id, setId] = useState(0);
    // =================================================================
    
    // محاسبه حداکثر تعداد مجاز پارکینگ بر اساس تعداد نفرات
    const calculateMaxAllowedParking = () => {
        if (!reserve || !reserve.reserve_Users) return 0;
        // حداکثر به ازای هر 2 نفر 1 پارکینگ
        const maxAllowed = Math.floor(reserve.reserve_Users.length / 2);
        return maxAllowed;
    };
    
    // بررسی اعتبار تعداد پارکینگ
    const validateParkingCount = (count) => {
        const maxAllowed = calculateMaxAllowedParking();
        const currentCount = parkingReserve?.count || 0;
        
        // اگر مقدار جدید بیشتر از حداکثر مجاز باشد
        if (count > maxAllowed) {
            Modal.warning({
                title: 'تعداد پارکینگ غیرمجاز',
                content: `شما مجاز به رزرو حداکثر ${maxAllowed} پارکینگ هستید .`,
                okText: 'متوجه شدم',
                okType: 'primary',
            });
            return false;
        }
        return true;
    };
    // =================================================================
    useEffect(() => {
        loadData();
    }, []);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetByReserveId_Parking_Reserve_Api(reserve.id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setParkingReserve(data.messageData.data);
                setId(data.messageData.data.id);
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const handleInputChange = async (value) => {
        // تبدیل مقدار null یا undefined به 0
        const sanitizedValue = value === null || value === undefined ? 0 : value;
        
        // اعتبارسنجی تعداد پارکینگ
        if (!validateParkingCount(sanitizedValue)) {
            // اگر اعتبارسنجی ناموفق بود، مقدار قبلی را نگه دار
            return;
        }
        
        setLoading(true);
        try {
            setParkingReserve({
                ...parkingReserve,
                count: sanitizedValue,
            });

            if (!id || id == 0) {
                const data = await Add_Parking_Reserve_Api({
                    reserveId: reserve.id,
                    count: sanitizedValue,
                });
                setId(parseInt(data.additional));
                setLoading(false);

                if (data.messageStatus == "Successful") {
                    showMessage(data.message, "Successful")
                }
                else
                    showMessage(data.message, "error")
            }
            else {
                const data = await Update_Parking_Reserve_Api({
                    id: id,
                    reserveId: reserve.id,
                    count: sanitizedValue,
                });

                setLoading(false);

                if (data.messageStatus == "Successful") {
                    showMessage(data.message, "Successful")
                }
                else
                    showMessage(data.message, "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    
    // تابع برای نمایش آیکون‌های ماشین بر اساس تعداد
    const renderCarIcons = () => {
        const count = parkingReserve?.count || 0;
        const icons = [];
        
        for (let i = 0; i < Math.min(count, 5); i++) {
            icons.push(
                <CarOutlined 
                    key={i} 
                    style={{ 
                        fontSize: '20px', 
                        color: '#1890ff',
                        marginRight: '5px'
                    }} 
                />
            );
        }
        
        if (count > 5) {
            icons.push(
                <Text key="more" type="secondary" style={{ marginLeft: '5px' }}>
                    +{count - 5}
                </Text>
            );
        }
        
        return icons;
    };

    // محاسبه قیمت کل
    const calculateTotalPrice = () => {
        const count = parkingReserve?.count || 0;
        const pricePerNight = parkingReserve?.price || 0;
        return count * pricePerNight;
    };
    
    // محاسبه حداکثر مجاز برای نمایش
    const maxAllowedParking = calculateMaxAllowedParking();
    const currentCount = parkingReserve?.count || 0;
    const userCount = reserve?.reserve_Users?.length || 0;

    return (
        <div className='container' style={{ 
            backgroundColor: '#f8f9fa',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            margin: '10px 0'
        }}>
            <Row gutter={[16, 16]} align="middle">
                {/* سمت راست: عنوان و آیکون */}
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <Space>
                            <CarOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
                            <Text strong style={{ fontSize: '16px' }}>
                                تعداد پارکینگ مورد نیاز
                            </Text>
                            <Tooltip title={`حداکثر ${maxAllowedParking} پارکینگ مجاز `}>
                                <InfoCircleOutlined style={{ color: '#8c8c8c' }} />
                            </Tooltip>
                        </Space>
                        
                        {/* نمایش اطلاعات تعداد نفرات و مجوز پارکینگ */}
                        <Space direction="vertical" size={2}>
                            {/* <Text type="secondary" style={{ fontSize: '12px' }}>
                                تعداد نفرات: {userCount} نفر
                            </Text> */}
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                مجوز پارکینگ: {maxAllowedParking} عدد
                            </Text>
                        </Space>
                        
                        {/* نمایش آیکون ماشین‌ها */}
                        {currentCount > 0 && (
                            <Space style={{ marginTop: '8px' }}>
                                {renderCarIcons()}
                            </Space>
                        )}
                    </Space>
                </Col>

                {/* وسط: input number */}
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <InputNumber 
                            min={0}
                            max={maxAllowedParking}
                            style={{ 
                                width: '100%', 
                                borderRadius: '8px',
                                backgroundColor: 'white',
                                borderColor: currentCount > maxAllowedParking ? '#ff4d4f' : '#d9d9d9'
                            }}
                            size="large"
                            disabled={reportMode || maxAllowedParking === 0}
                            onChange={handleInputChange}
                            value={currentCount}
                            addonBefore={<CarOutlined />}
                            addonAfter="عدد"
                            controls={{
                                upIcon: <span style={{ fontSize: '18px' }}>+</span>,
                                downIcon: <span style={{ fontSize: '18px' }}>-</span>
                            }}
                            status={currentCount > maxAllowedParking ? "error" : ""}
                        />
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            {maxAllowedParking === 0 ? (
                                <Text type="danger">شرایط لازم برای رزرو پارکینگ وجود ندارد</Text>
                            ) : (
                                `حداقل ۰ و حداکثر ${maxAllowedParking} پارکینگ`
                            )}
                        </Text>
                        
                        {/* نمایش هشدار اگر تعداد فعلی بیشتر از مجاز باشد */}
                        {currentCount > maxAllowedParking && (
                            <Text type="danger" style={{ fontSize: '12px' }}>
                                ⚠️ تعداد پارکینگ بیش از حد مجاز است
                            </Text>
                        )}
                    </Space>
                </Col>

                {/* سمت چپ: اطلاعات قیمت */}
                <Col xs={24} sm={24} md={8} lg={6} xl={6}>
                    <Space direction="vertical" size="small" style={{ 
                        backgroundColor: 'white',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #f0f0f0',
                        width: '100%',
                        borderColor: currentCount > maxAllowedParking ? '#ff4d4f' : '#f0f0f0'
                    }}>
                        <Row justify="space-between">
                            <Col>
                                <Text type="secondary">قیمت هر شب:</Text>
                            </Col>
                            <Col>
                                <Text strong>
                                    {parkingReserve?.price?.toLocaleString('fa-IR') || '۰'} ریال
                                </Text>
                            </Col>
                        </Row>
                        
                        {currentCount > 0 && (
                            <>
                                <Row justify="space-between">
                                    <Col>
                                        <Text type="secondary">تعداد:</Text>
                                    </Col>
                                    <Col>
                                        <Text strong 
                                            style={{ 
                                                color: currentCount > maxAllowedParking ? '#ff4d4f' : 'inherit'
                                            }}
                                        >
                                            {currentCount} پارکینگ
                                            {currentCount > maxAllowedParking && ' ⚠️'}
                                        </Text>
                                    </Col>
                                </Row>
                                <Row justify="space-between" style={{ borderTop: '1px solid #f0f0f0', paddingTop: '8px' }}>
                                    <Col>
                                        <Text type="secondary">جمع کل:</Text>
                                    </Col>
                                    <Col>
                                        <Text strong 
                                            type={currentCount > maxAllowedParking ? "danger" : "success"}
                                        >
                                            {calculateTotalPrice().toLocaleString('fa-IR')} ریال
                                        </Text>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Space>
                </Col>

                {/* وضعیت رزرو */}
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                    <div style={{
                        padding: '12px',
                        borderRadius: '8px',
                        backgroundColor: currentCount > maxAllowedParking ? '#fff2f0' : 
                                       currentCount > 0 ? '#f6ffed' : '#fff2e8',
                        border: `1px solid ${currentCount > maxAllowedParking ? '#ffccc7' : 
                                   currentCount > 0 ? '#b7eb8f' : '#ffbb96'}`
                    }}>
                        <Space direction="vertical" size="small" style={{ width: '100%' }}>
                            <Text strong>
                                {currentCount > maxAllowedParking ? '⚠️ پارکینگ بیش از حد مجاز' :
                                 currentCount > 0 ? '✅ پارکینگ رزرو شده' : '⚠️ پارکینگ رزرو نشده'}
                            </Text>
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                {currentCount > maxAllowedParking 
                                    ? `تعداد پارکینگ (${currentCount}) بیش از حد مجاز (${maxAllowedParking}) است`
                                    : currentCount > 0 
                                    ? `${currentCount} جای پارک برای شما رزرو شده است`
                                    : 'در صورت نیاز به پارکینگ، تعداد مورد نیاز را وارد کنید'}
                            </Text>
                            {maxAllowedParking > 0 && (
                                <Text type="secondary" style={{ fontSize: '11px' }}>
                                    (مجاز: {maxAllowedParking} پارکینگ )
                                </Text>
                            )}
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>
    )
}